export default __webpack_public_path__ + "4b600aa9aebee4a852d8ff1cbb813355.woff";